/*Package importing*/
import React from 'react';

/*Import custom components and assets*/

const Loader = () => {
  return (
    <div className="row text-center e-zappit-loader-wrapper">
      <div className="text-center col-lg-12">
        <div className="spinner-border e-zappit-loader" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
